import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
} from '@atlassian/ufo-experimental/experience-types';
import { UFOExperience } from '@atlassian/ufo-experimental/experience';

const COMPONENT = 'search-page';

/**
 * This experience should be started inside product codebases.
 */
export const searchPageLoadUFOExperience: UFOExperience = new UFOExperience('load', {
	type: ExperienceTypes.Load,
	performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	platform: { component: COMPONENT },
});

export const searchResultsLoadUFOExperience: UFOExperience = new UFOExperience(
	'search-results-load',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: COMPONENT },
		timings: [
			{ key: 'request', startMark: 'request_start', endMark: 'request_end' },
			{ key: 'render', startMark: 'render_start', endMark: 'render_end' },
		],
	},
);

export const searchResultsLoadUFOExperienceStart: () => Promise<void> = async (): Promise<void> => {
	if (!searchResultsLoadUFOExperience.state.final) {
		await searchResultsLoadUFOExperience.abort({ metadata: { reason: 'restarted' } });
	}
	searchResultsLoadUFOExperience.start();
};

export const searchResultsLoadUFOExperienceSuccess: ({
	queryLength,
	wordCount,
}: {
	queryLength: number;
	wordCount: number;
}) => void = ({ queryLength, wordCount }: { queryLength: number; wordCount: number }): void => {
	searchResultsLoadUFOExperience.success({
		metadata: { queryLength, wordCount },
	});
};

export const searchResultsLoadUFOExperienceError: () => void = (): void => {
	searchResultsLoadUFOExperience.failure();
};
